import React, { useCallback, useState } from "react";
import CsvBtn from "../CsvBtn/CsvBtn";
import "./css/index.css";
type Filter = {
  type: string;
  title: string;
};

type Props = {
  title: string;
  placeholder: string;
  isExel: boolean;
  filter: never[] | Filter[];
  Search?: (filter: string[], text: string) => void;
  headers?: string[];
  csvData?: () => Promise<any[]>;
  csvTitle?: string;
};

const ListSearchSection = ({
  title,
  placeholder,
  isExel,
  filter,
  headers,
  csvData,
  csvTitle,
  Search: SearchActive,
}: Props) => {
  const [filterArr, setfilterArr] = useState<string[]>([]);
  const [Search, setSearch] = useState("");
  const FilterChange = useCallback(
    (type: string) => {
      const clone = filterArr.slice();
      const Index = clone.indexOf(type);
      if (Index < 0) {
        clone.push(type);
      } else {
        clone.splice(Index, 1);
      }
      if (SearchActive) {
        SearchActive(clone, Search);
      }
      setfilterArr(clone);
    },
    [filterArr, SearchActive, Search]
  );

  return (
    <form
      className="list-search-section"
      onSubmit={(e) => {
        if (SearchActive) {
          SearchActive(filterArr, Search);
        }
        e.preventDefault();
      }}
    >
      <div className="list-search-title">{title}</div>
      <div className="list-search-content-wrapper">
        <div className="list-search-filter">
          {filter.map(({ type, title }, idx) => {
            return (
              <div
                key={idx}
                className="search-filter-wrapper"
                onClick={() => {
                  FilterChange(type);
                }}
              >
                <div
                  className={`circle ${
                    filterArr.indexOf(type) > -1 ? "check" : ""
                  }`}
                >
                  {filterArr.indexOf(type) > -1 ? (
                    <img src="/assets/common/check.svg" alt="" />
                  ) : undefined}
                </div>
                <div className="title">{title}</div>
              </div>
            );
          })}
        </div>
        <div className="search_box">
          <input
            type="text"
            className="type2"
            placeholder={placeholder}
            onChange={(e) => {
              setSearch(e.target.value);
            }}
          ></input>
          <img className="search" src="/assets/common/search.svg"></img>
        </div>
        <button
          className="search-btn"
          onClick={() => {
            if (SearchActive) {
              SearchActive(filterArr, Search);
            }
          }}
        >
          검색
        </button>
        {isExel && headers && csvData && csvTitle ? (
          <CsvBtn headers={headers} getCsvData={csvData} title={csvTitle} />
        ) : undefined}
      </div>
    </form>
  );
};

export default ListSearchSection;
